module.exports = __webpack_public_path__ + "assets/img/gangkou.867a9f91.png";